import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Container, Row, Col } from "reactstrap"
import GridGallery from "react-grid-gallery"

const Gallery = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { relativeDirectory: { eq: "drive" } }) {
        edges {
          node {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  //images is an array of string image src's
  let images = []
  Object.values(data.allFile.edges).forEach(key => {
    const regex = /\d+/g
    const height = parseInt(
      key.node.childImageSharp.fluid.sizes.match(regex)[0]
    )
    const width = height * key.node.childImageSharp.fluid.aspectRatio
    const obj = {
      src: key.node.childImageSharp.fluid.src,
      thumbnail: key.node.childImageSharp.fluid.src,
      thumbnailWidth: width,
      thumbnailHeight: height,
    }
    images.unshift(obj)
  })

  return (
    <Layout showHome="true">
      <SEO title="Gallery" />
      <h1 className="text-center display-4 pt-3 raleway-900">Photo Gallery</h1>
      <Container>
        <Row>
          <Col className="my-3">
            <GridGallery images={images} backdropClosesModal />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Gallery
